export enum REPORT_STATUS {
  DRAFT = 1,
  SAVED,
  SUBMITTED
}

export const ReportStatuses: { id: REPORT_STATUS; name: string; type: string }[] = [
  {
    id: REPORT_STATUS.DRAFT,
    name: 'Draft',
    type: 'warning'
  },
  {
    id: REPORT_STATUS.SAVED,
    name: 'Saved',
    type: 'success'
  },
  {
    id: REPORT_STATUS.SUBMITTED,
    name: 'Submitted',
    type: 'info'
  }
];
